import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { DashboardItem } from '../models';
import { ODataResponse } from '../models/odata-response.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient) { }

  getDashboardItems(): Observable<DashboardItem[]> {
    const endpoint = environment.endpoints?.baseApi;
    return this.http.get<ODataResponse<DashboardItem[]>>(`${endpoint?.url || ''}odata/v2/DashboardItems?$filter=isActive eq true`)
      .pipe(map(val => val.value || []));
  }
}
